/**
 * Resolves a possibly-relative URL (as stored on a DB row, e.g. an uploaded
 * cover image path) against an origin. Already-absolute http(s) URLs pass
 * through unchanged.
 *
 * Shared by every SSR meta/body builder (blog posts, CMS pages, and future
 * entities) so there is exactly one place that decides what "absolute"
 * means for this kind of value.
 */
export function absoluteUrl(maybeRelative: string, origin: string): string {
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return new URL(maybeRelative, origin).toString();
}
